import * as React from 'react';

import { useQuery } from '@apollo/client';

import type {
  ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQuery,
  ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQueryVariables,
} from 'bundles/naptimejs/resources/__generated__/ProgramCurriculumProductsV1';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import ProgramCurriculumProductsV1 from 'bundles/naptimejs/resources/programCurriculumProducts.v1';
import { toOrgHomeTab } from 'bundles/program-common/links';
import { TabName } from 'bundles/program-home/components/enterprise-home/EnterpriseHomeTabs';
import { MyRecentActivityBaseComponent } from 'bundles/program-home/components/single-program/MyRecentActivity';
import ProgramCurriculumLatestEnrolledCoursesForOrg from 'bundles/program-home/queries/ProgramCurriculumLatestEnrolledCoursesForOrgQuery';

type PropsFromCaller = {
  userId: number;
  thirdPartyOrganizationId: string;
  thirdPartyOrgSlug: string;
};

const MyRecentActivityForMultiProgram: React.FC<PropsFromCaller> = ({
  userId,
  thirdPartyOrgSlug,
  thirdPartyOrganizationId,
}) => {
  const { data, loading } = useQuery<
    ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQuery,
    ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQueryVariables
  >(ProgramCurriculumLatestEnrolledCoursesForOrg, {
    variables: {
      thirdPartyOrganizationId,
      userId: userId.toString(),
    },
  });

  const product =
    data?.ProgramCurriculumProductsV1?.latestEnrolledCourseActivitiesByThirdPartyOrganizationAndUser?.elements?.[0];
  const inProgressCourse = product && new ProgramCurriculumProductsV1(product);
  const programId = product?.programId;
  const viewMyCoursesUrl = toOrgHomeTab(thirdPartyOrgSlug, TabName.MyCourses);

  return (
    <MyRecentActivityBaseComponent
      programId={programId}
      thirdPartyOrganizationId={thirdPartyOrganizationId}
      viewMyCoursesUrl={viewMyCoursesUrl}
      userId={userId}
      inProgressCourse={inProgressCourse}
      loading={loading}
    />
  );
};

export default MyRecentActivityForMultiProgram;
